
import React, { useState } from 'react';
import {Form, FormGroup, Input, ControlLabel, Button} from 'rsuite';
import axios from 'axios';

import FormFeedback from 'reactstrap/lib/FormFeedback';

import ValidateEmail from './validators/email';

const FORM_STAGES = {
    EMAIL: 'email',
    OTP: 'otp'
};
const apiRoot = process.env.REACT_APP_API_ROOT;

function CustomForm () {
    const [active, setActive] = useState(FORM_STAGES.EMAIL);
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [emailError, setEmailError] = useState(null);
    const [otpMessage, setOtpMessage] = useState(null);
    const onFormSubmit = (event) => {
        if (active === FORM_STAGES.EMAIL) {
            emailSubmit();
        } else if (active === FORM_STAGES.OTP) {
            otpSubmit();
        }
    }
    const emailSubmit = () => {
        const isValid = ValidateEmail(email);
        if (isValid) {
            axios.get(`${apiRoot}/dev/otp/${email}`).then(result => {
                const data = result.data;
                const {hash, email} = data;
                if (hash && email) {
                    localStorage.setItem('hash', hash);
                    localStorage.setItem('email', email);
                }
                setOtpMessage(null);
                setActive('otp');
            }).catch(error => {
                console.error(error);
            });
        } else {
            setEmailError('Not valid email address');
        }
    }
    const otpSubmit = () => {
        const hash = localStorage.getItem('hash');
        const email = localStorage.getItem('email');
        if (email && hash) {
            axios.post(`${apiRoot}/dev/otp/verify`, {otp: otp, email: email, hash: hash}).then(result => {
                setOtpMessage('OTP verified successfully');
            }).catch(error => {
                setOtpMessage('Invalid OTP');
                console.error(error);
            });
        } else {
            setOtpMessage('You first need to recieve OTP in your email!');
        }
    }
    const handleEmailChange = (value) => {
        setEmail(value);
        if (ValidateEmail(value)) {
            setEmailError(null);
        } else {
            setEmailError('Not valid email address');
        }
    }
    const handleOtpChange = (value) => {
        setOtp(value);
    }
    const handleActive = () => {
        if (active === FORM_STAGES.EMAIL) {
            setActive(FORM_STAGES.OTP);
        } else {
            setActive(FORM_STAGES.EMAIL)
        }
    }
    const storedEmail = localStorage.getItem('email');
    return (
        <Form onSubmit={onFormSubmit} className='email-form'>
            {active === FORM_STAGES.EMAIL &&
                <FormGroup>
                    <ControlLabel>Email</ControlLabel>
                    <Input name="email" type="email" value={email} onChange={handleEmailChange}/>
                    {emailError && <FormFeedback style={{color: "red"}}>{emailError}</FormFeedback>}
                </FormGroup>
            }
            {active === FORM_STAGES.OTP && 
                <FormGroup>
                    <ControlLabel>OTP</ControlLabel>
                    <Input name="otp" type="text" value={otp} onChange={handleOtpChange}/>
                    {(!otpMessage && storedEmail) && <FormFeedback style={{marginTop: "5px"}}>{`check your email ${storedEmail} for OTP`}</FormFeedback>}
                    {otpMessage && <FormFeedback>{otpMessage}</FormFeedback>}
                </FormGroup>
            }
            <FormGroup>
                <Button type="submit" appearance="primary">Submit</Button> &nbsp;&nbsp;&nbsp;
                <Button onClick={handleActive} appearance="link">{active === FORM_STAGES.EMAIL ? 'Go to OTP' : 'Go to Email'}</Button>
            </FormGroup>
      </Form>
    );
}

export default CustomForm;